module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('audio', {
    ref: "audio",
    attrs: {
      "src": _vm.audioSrc,
      "autoplay": _vm.autoplay,
      "controls": ""
    }
  }, [_vm._v("\n    您的瀏覽器不支援 audio 標籤功能。\n  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.toggleAutoplay()
      }
    }
  }, [_vm._v("toggle autoplay")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.autoplay),
      expression: "autoplay"
    }]
  }, [_vm._v("autoplay enabled")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bd58329"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/x-audio.vue
// module id = 971
// module chunks = 1